import React, { useEffect, useState } from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import ExportIcon from '@material-ui/icons/Assessment';
import { excelExportFunction, ISheet } from '../../../../components/ExcelExportButton';

export interface IExcelByGameProps {
    list: any[];
}

const ExcelByGame: React.FC<IExcelByGameProps> = ({ list }) => {

    const [exportSheets, setExportSheets] = useState<ISheet[]>([]);

    useEffect(() => {

        if (!list) return;

        let sheets = [];

        sheets.push({
            sheetName: "Top Points",
            sheetColumns: [
                { title: "Name", name: "name" },
                { title: "Surname", name: "surname" },
                { title: "Email", name: "email" },
                { title: "General", name: "general" },
                { title: "Points", name: "points" },
            ],
            sheetData: list || []
        });

        setExportSheets(sheets);

    }, [list]);

    return (
        <IconButton onClick={() => excelExportFunction({sheets: exportSheets})}>
            <Tooltip title="Export" aria-label="Export">
                <ExportIcon />
            </Tooltip>
        </IconButton>
    );
}

export default ExcelByGame;